import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Consumption } from '../Models/Consumption';
import { ConsumptionPeriod } from '../Models/ConsumptionPeriod';
import { UntypedFormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { PHBHPFeaturePackageConsumptionService } from "./../ph-bhp-feature-package-consumption.service";
import { ActivatedRoute, Router } from '@angular/router';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Subscription } from 'rxjs';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-view-month-consumption',
  templateUrl: './ph-bhp-view-month-consumption.component.html',
  styleUrls: ['./ph-bhp-view-month-consumption.component.css']
})
export class PhBhpViewMonthConsumptionComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  isMilliliter = true;
  isLiter = true;
  viewFlag: string = 'liter';
  consumptionJsonData;
  consumptionID: number;
  consumptionPeriodID: number;
  consumptionData: Array<Consumption> = [];
  consumptionPeriodData: Array<ConsumptionPeriod> = [];
  consumptionQuarterPeriodForm: UntypedFormGroup;
  milliliter: any;
  liter: any;
  consumptionValue: any;
  items: UntypedFormArray;
  periodNumber: number;
  haiOccurrences: number;
  haiEnabled: boolean = false;
  viewConsumption: boolean = false;
  editconsumptionDisabled: boolean = false;
  currentMonth = [
    "CONSUMPTION.JANUARY",
    "CONSUMPTION.FEBRUARY",
    "CONSUMPTION.MARCH",
    "CONSUMPTION.APRIL",
    "CONSUMPTION.MAY",
    "CONSUMPTION.JUNE",
    "CONSUMPTION.JULY",
    "CONSUMPTION.AUGUST",
    "CONSUMPTION.SEPTEMBER",
    "CONSUMPTION.OCTOBER",
    "CONSUMPTION.NOVEMBER",
    "CONSUMPTION.DECEMBER"
  ];

  consumptionPeriodDetail: Array<ConsumptionPeriod> = [];
  consumptionConfigDetail: any = [];
  @Output() childData = new EventEmitter();
  translationKeys: typeof TranslationKeys = TranslationKeys;
  consumptionYearConfiguration: any;

  constructor(private service: PHBHPFeaturePackageConsumptionService, private activatedRoute: ActivatedRoute, private router: Router, private fb: UntypedFormBuilder, private layoutService: PHBHPLayoutPackageService) { }

  ngOnInit() {
    this.consumptionID = parseInt(this.activatedRoute.snapshot.paramMap.get('Id'));

    if (this.layoutService.institutionID) {
      this.getConfigList();
      this.getConsumptionPeriodLis();
    }
    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((Id) => {
      this.layoutService.institutionID = Id
      this.getConfigList();
      this.getConsumptionPeriodLis();
      this.router.navigate(['/consumption/new']);
    });
    this.periodNumber = 1;
    this.consumptionQuarterPeriodForm = this.fb.group({
      items: this.fb.array([])
    });
    this.items = this.consumptionQuarterPeriodForm.get('items') as UntypedFormArray;
    for (let i = 0; i < this.currentMonth.length; i++) {
      this.periodNumber = i + 1;
      this.items.push(this.createItem(i));
    }
  }
  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
  getConsumptionPeriodLis() {
    this.service.getConsumptionPeriodById(this.consumptionID).subscribe((res: any = []) => {
      this.consumptionPeriodDetail = res;

      for (let i = 0; i < this.consumptionPeriodDetail.length; i++) {
        this.items.at(i).patchValue({
          consumptionValue: this.consumptionPeriodDetail[i].consumptionValue,
          patientDays: this.consumptionPeriodDetail[i].patientDays,
          periodNumber: this.consumptionPeriodDetail[i].periodNumber,
          consumptionPeriodID: this.consumptionPeriodDetail[i].consumptionPeriodID,
          haiOccurrences: this.consumptionPeriodDetail[i].haiOccurrences || ''

        });
      }
    });
  }
  getConfigList() {
    this.service.getSOPConsumptionByConsumptionId(this.consumptionID).subscribe((res: any) => {
      this.consumptionData = res;
      this.service.getConsumptionConfigByInstitutionId(this.layoutService.institutionID).subscribe((res: Array<any> = []) => {
        this.consumptionConfigDetail[0] = res;
        this.consumptionYearConfiguration = this.service.getConsumptionYearConfiguration(this.consumptionConfigDetail[0].consumptionConfigs, this.consumptionData[0].year)
        this.haiEnabled = this.consumptionConfigDetail[0].enableHAITracking;
      });
    });
  }


  EditConsumption() {
    this.editconsumptionDisabled = true;
    this.viewConsumption = true;
    this.consumptionQuarterPeriodForm.enable();
    this.childData.emit({
      key: true
    })
  }

  updateConsumptionPeriod(value) {
    this.convertCommaToDot();
    var formValue1: Boolean = false;
    var consumptionValueFlag: Boolean = false;
    var patientDaysFlag: Boolean = false;
    for (let i = 0; i < this.consumptionQuarterPeriodForm.value.items.length; i++) {
      if (this.consumptionQuarterPeriodForm.value.items[i].consumptionValue == null) {
        this.consumptionQuarterPeriodForm.value.items[i].consumptionValue = "";
      }
      if (this.consumptionQuarterPeriodForm.value.items[i].patientDays == null || this.consumptionQuarterPeriodForm.value.items[i].patientDays == 0) {
        this.consumptionQuarterPeriodForm.value.items[i].patientDays = "";
      }
      if (this.consumptionQuarterPeriodForm.value.items[i].consumptionValue != "" && this.consumptionQuarterPeriodForm.value.items[i].patientDays == "") {
        patientDaysFlag = true;
        break;
      } else if (this.consumptionQuarterPeriodForm.value.items[i].consumptionValue == "" && this.consumptionQuarterPeriodForm.value.items[i].patientDays != "") {
        consumptionValueFlag = true;
        break;
      } else if (this.consumptionQuarterPeriodForm.value.items[i].consumptionValue != "" && this.consumptionQuarterPeriodForm.value.items[i].patientDays != "") {
        formValue1 = true;
      }
    }

    if (patientDaysFlag) {
      this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.SUBMISSION_RULE.MISSING_PATIENT_DAYS"));
    } else if (consumptionValueFlag) {
      if (this.consumptionConfigDetail[0].amountMeasured == "u") {
        this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.SUBMISSION_RULE.MISSING_USED_DATA"));
      } else if (this.consumptionConfigDetail[0].amountMeasured == "p") {
        this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.SUBMISSION_RULE.MISSING_PURCHASED_DATA"));
      }
    } else if (formValue1) {
      this.saveConsupmtionPeriodforMonth()
    } else {
      this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.NO_CHANGES_TO_SAVE"));
    }
  }

  convertCommaToDot() {
    this.consumptionQuarterPeriodForm.value.items.forEach(item => {
      if (typeof item.consumptionValue === 'string') {
        item.consumptionValue = item.consumptionValue.replace(',', '.');
      }
    });
  }

  saveConsupmtionPeriodforMonth() {
    var id = this.consumptionID;
    var value = this.consumptionQuarterPeriodForm.value;
    this.service.updateConsumptionPeriodById(id, value.items).subscribe((res: any) => {
      //   this.layoutService.showSuccess(this.layoutService.translateText("CONSUMPTION.CONSUMPTION.SUCCESSFULLY_ADDED_DETAILS"));
      this.router.navigate(['/consumption/past']);
    })
    this.childData.emit({
      key: false,
      val: "save"
    })
  }

  cancelConsupmtionPeriod() {
    this.getConsumptionPeriodLis()
    this.editconsumptionDisabled = false;
    this.viewConsumption = false;
    this.childData.emit({
      key: false,
      val: "cancel"
    })
  }

  amountMeasure() {
    if (this.consumptionYearConfiguration?.amountMeasured === 'u') {
      return this.layoutService.translateText('CONSUMPTION.USED.DISPLAY_TEXT');
    } else if (this.consumptionYearConfiguration?.amountMeasured === 'p') {
      return this.layoutService.translateText('CONSUMPTION.PURCHASED.DISPLAY_TEXT');
    }
  }

  unitMeasure() {
    if (this.consumptionYearConfiguration?.unitOfMeasure === 'l') {
      return this.layoutService.translateText(this.translationKeys.Dashboard.inLiters);
    } else if (this.consumptionYearConfiguration?.unitOfMeasure === 'm') {
      return this.layoutService.translateText('CONSUMPTION.AMOUNT.IN_MILLILITERS');
    }
  }

  createItem(index): UntypedFormGroup {
    return this.fb.group({
      consumptionID: this.consumptionID,
      consumptionValue: new UntypedFormControl({
        value: '',
        disabled: true
      }),
      patientDays: new UntypedFormControl({
        value: '',
        disabled: true
      }),
      haiOccurrences: new UntypedFormControl({
        value: '',
        disabled: true
      }),
      periodNumber: this.periodNumber,
      consumptionPeriodID: this.consumptionPeriodID
      //  currentMonth: this.currentMonth[index]
    })
  }

  getControls(frmGrp: UntypedFormGroup, key: string) {
    return (<UntypedFormArray>frmGrp.controls[key]).controls;
  }

  isLiters() {
    return this.consumptionYearConfiguration?.unitOfMeasure === 'l';
  }

  isMilliliters() {
    return this.consumptionYearConfiguration?.unitOfMeasure === 'm';
  }

}
